import React, { useId } from 'react';
import { InputNumber } from 'primereact/inputnumber';
import FieldShell from './FieldShell';

/**
 * AppNumberField — wraps PrimeReact InputNumber with FieldShell.
 * Returns number | null via onValueChange.
 */
const AppNumberField = ({
    label,
    value,
    onValueChange,
    placeholder,
    helperText,
    errorMessage,
    required = false,
    invalid = false,
    disabled = false,
    readOnly = false,
    fluid = true,
    className = '',
    trailing,
    mode,
    minFractionDigits,
    maxFractionDigits,
    min,
    max,
    useGrouping = true,
    onKeyDown,
    ...rest
}) => {
    const autoId = useId();
    const id = rest.id || autoId;

    // El autocompletado del navegador manda keydown sin `code` y PrimeReact
    // 10.6.3 hace `event.code.startsWith(...)`: truena la pantalla. Con
    // preventDefault PrimeReact se sale antes; el valor entra igual por `input`.
    const handleKeyDown = (event) => {
        if (typeof event.code !== 'string') {
            event.preventDefault();
            return;
        }
        onKeyDown?.(event);
    };

    const inputCls = [
        'fk-input',
        invalid && 'fk-input--invalid',
        disabled && 'fk-input--disabled',
        readOnly && 'fk-input--readonly',
    ].filter(Boolean).join(' ');

    return (
        <FieldShell
            label={label}
            htmlFor={id}
            required={required}
            helperText={helperText}
            errorMessage={errorMessage}
            invalid={invalid}
            disabled={disabled}
            readOnly={readOnly}
            fluid={fluid}
            className={className}
            trailing={trailing}
        >
            <div className={inputCls}>
                <InputNumber
                    inputId={id}
                    value={value}
                    onValueChange={onValueChange}
                    placeholder={placeholder}
                    disabled={disabled}
                    readOnly={readOnly}
                    mode={mode}
                    minFractionDigits={minFractionDigits}
                    maxFractionDigits={maxFractionDigits}
                    min={min}
                    max={max}
                    useGrouping={useGrouping}
                    {...rest}
                    onKeyDown={handleKeyDown}
                />
            </div>
        </FieldShell>
    );
};

export default AppNumberField;
